// Dragula

'use strict';

watch('[data-sortable]', container => {
    import(/* webpackChunkName: 'dragula' */ 'dragula')
        .then(({default: dragula}) => {
            window.Dragula = dragula;

            let sortables = container.dataset.sortable,
                userOptions = container.dataset.sortableOptions ? JSON.parse(container.dataset.sortableOptions) : {},
                list = [];

            if (sortables) {
                sortables = JSON.parse(sortables);

                for (let i = 0; i < sortables.length; i++) {
                    list.push((document.querySelector('#' + sortables[i])));
                }
            } else {
                list = [containers[0]];
            }

            window.Dragula(list, userOptions);
        })
        .catch(console.warn);
})
